import {
  State,
  Action,
  StateContext,
  Selector,
  Store,
  Select,
} from "@ngxs/store";
import { patch } from "@ngxs/store/operators";
import { Injectable } from "@angular/core";
import * as GarageActions from "./garage.action";
import { GarageService } from "./garage.service";
import { BannerService } from "../../shared/services/banner.service";
import * as GarageModels from "../../models/garage/garage";
import { HelperService } from "../../../../src/app/services/helper/helper.service";
import { empty } from "rxjs";
import { GarageSearchModel } from "../../models/garage/garageSearch";
import { HttpEventType } from "@angular/common/http";
import { SaveState } from "../../models/commonModels";
import { saveAs } from "file-saver";
import * as Models from "../../models/commonModels";

export interface GarageStateModel {
  GarageDictionaryList: GarageModels.GarageDictionaryListModel;
  GarageList: GarageModels.GarageListModel;
  GarageSearch: GarageSearchModel;
  Garage: Models.Response<GarageModels.GarageModel>;

  SaveGarage: SaveState;
  LastGroupMesage: GarageModels.GarageGroupMessageViewModel;
  GarageLocations: GarageModels.GarageLocationListModel;
  GarageDiscount: Models.Response<GarageModels.GarageDiscountPreviewModel[]>;
  GarageDiscountTemplate: Models.Response<GarageModels.GarageDiscountPreviewModel[]>;
  ImportGarageDiscountStatus: boolean;
  Report: Models.ReportProcessing;
}

@State<GarageStateModel>({
  name: "garageState",
  defaults: {
    GarageDictionaryList: null,
    GarageList: null,
    GarageSearch: null,
    Garage: null,
    SaveGarage: null,
    LastGroupMesage: null,
    GarageLocations: null,
    GarageDiscount: null,
    GarageDiscountTemplate: null,
    ImportGarageDiscountStatus: null,
    Report: null
  },
})
@Injectable()
export class GarageState {

  constructor(
    private helperService: HelperService,
    private garageService: GarageService,
    private bannerService: BannerService
  ) { }


  PatchReportContext(Name:string,IsProcessing:boolean, Context: StateContext<GarageStateModel>) {
    if (IsProcessing) {
      Context.setState(
        patch({
          Report: Models.ReportProcessing.Start(Name),
        })
      );
    }
    else {
      Context.setState(
        patch({
          Report: Models.ReportProcessing.End(Name),
        })
      );
    }
  }

  @Selector()
  static GarageLocations(state: GarageStateModel) {
    return state.GarageLocations;
  }

  @Selector()
  static GarageDictionaryList(state: GarageStateModel) {
    return state.GarageDictionaryList;
  }

  @Selector()
  static GarageLastGroupMessage(state: GarageStateModel) {
    return state.LastGroupMesage;
  }

  @Selector()
  static GarageList(state: GarageStateModel) {
    return state.GarageList;
  }

  @Selector()
  static GarageSearch(state: GarageStateModel) {
    return state.GarageSearch;
  }

  @Selector()
  static Garage(state: GarageStateModel) {
    return state.Garage;
  }

  @Selector()
  static SaveGarage(state: GarageStateModel) {
    return state.SaveGarage;
  }

  @Selector()
  static GarageDiscount(state: GarageStateModel) {
    return state.GarageDiscount;
  }

  @Selector()
  static GarageDiscountTemplate(state: GarageStateModel) {
    return state.GarageDiscountTemplate;
  }

  @Selector()
  static ImportGarageDiscountStatus(state: GarageStateModel) {
    return state.ImportGarageDiscountStatus;
  }

  @Selector()
  static Report(state: GarageStateModel) {
    return state.Report;
  }


  // *** Garage actions ***

  @Action(GarageActions.GetGarageDictionary)
  getGarageDictionary(
    context: StateContext<GarageStateModel>,
    action: GarageActions.GetGarageDictionary
  ) {
    const errorMessage = "Błąd pobierania słownika serwisów.";

    context.setState(
      patch({
        GarageDictionaryList: null,
      })
    );

    this.garageService.getDictionary(action.Search).subscribe(
      (ret) => {
        if (ret.Success) {
          context.setState(
            patch({
              GarageDictionaryList: ret,
            })
          );
        } else {
          this.bannerService.error(errorMessage);
        }
      },
      (error) => {
        this.helperService.SaveException(
          "GarageActions.GetGarageDictionary",
          error
        );

        this.bannerService.error(errorMessage);
      }
    );
  }

  @Action(GarageActions.GetGarageList)
  getGarageList(
    context: StateContext<GarageStateModel>,
    action: GarageActions.GetGarageList
  ) {
    function patchContext(
      list: GarageModels.GarageListModel,
      loading: boolean
    ) {
      context.setState(
        patch({
          GarageList: list,
        })
      );
    }
    const emptyResponse = new GarageModels.GarageListModel();

    patchContext(null, true);
    this.garageService.getList(action.search).subscribe(
      (data) => {
        if (data.Success) { 
          patchContext(data, false);
        } else {
          patchContext(emptyResponse, false);
        }
      },
      (error) => {
        patchContext(emptyResponse, false);
        this.bannerService.error("Błąd pobierania listy serwisów.");
        this.helperService.SaveException("GetGarageList", error);
      }
    );
  }

  @Action(GarageActions.SetGarageSearch)
  setGarageSearch(
    context: StateContext<GarageStateModel>,
    action: GarageActions.SetGarageSearch
  ) {
    action.Search.CurrentPage = 1;

    context.setState(
      patch({
        GarageSearch: action.Search,
      })
    );

    this.helperService.consoleLog(action.Search);

    context.dispatch(new GarageActions.GetGarageList(action.Search));
  }

  @Action(GarageActions.SetGarageListPage)
  setGarageListPage(
    context: StateContext<GarageStateModel>,
    action: GarageActions.SetGarageSearch
  ) {
    context.setState(
      patch({
        GarageSearch: action.Search,
      })
    );

    this.helperService.consoleLog(action.Search);
    context.dispatch(new GarageActions.GetGarageList(action.Search));
  }

  @Action(GarageActions.ResetGarageSearch)
  resetGarageSearch(context: StateContext<GarageStateModel>) {
    const state = context.getState();

    const newSearch = new GarageSearchModel();

    newSearch.ItemsPerPage = state.GarageSearch.ItemsPerPage;

    context.setState(
      patch({
        GarageSearch: newSearch,
      })
    );

    context.dispatch(new GarageActions.GetGarageList(newSearch));
  }

  @Action(GarageActions.Create)
  create(
    context: StateContext<GarageStateModel>,
    action: GarageActions.Create
  ) {
    const errorMessage = "Błąd utworzenia nowego garażu.";

    this.garageService.create(action.Garage).subscribe(
      (ret) => {
        this.bannerService.success(`Nowy serwis ${action.Garage.Item.Name} został utworzony.`);

        context.setState(
          patch({
            Garage: ret,
          })
        );
      },

      (error) => {
        context.setState(
          patch({
            Garage: null,
          })
        );

        this.helperService.SaveException("GarageActions.Create", error);
        this.bannerService.error(errorMessage);
      },
      () => { }
    );
  }

  @Action(GarageActions.Set)
  set(context: StateContext<GarageStateModel>, action: GarageActions.Set) {
    const errorMessage = "Błąd zapisu szczegółów garażu.";

    this.garageService.set(action.Garage).subscribe(
      (ret) => {
        this.bannerService.success("Zmiany szczegółów garażu zapisane.");

        context.setState(
          patch({
            Garage: ret,
          })
        );
      },

      (error) => {
        context.setState(
          patch({
            Garage: null,
          })
        );

        this.helperService.SaveException("GarageActions.Set", error);

        this.bannerService.error(errorMessage);
      },
      () => { }
    );
  }

  @Action(GarageActions.Get)
  get(context: StateContext<GarageStateModel>, action: GarageActions.Get) {
    context.setState(
      patch({
        Garage: null,
      })
    );

    const errorMessage = "Błąd pobierania szczegółów garażu.";

    this.garageService.get(action.Garage).subscribe(
      (ret) => {
        if (ret.Success == true) {
          context.setState(
            patch({
              Garage: ret,
            })
          );
        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },
      (error) => {
        this.helperService.SaveException("GarageActions.Get", error);

        this.bannerService.error(errorMessage);
      }
    );
  }

  @Action(GarageActions.ResetSave)
  resetSave(context: StateContext<GarageStateModel>) {
    context.setState(
      patch({
        SaveGarage: null,
      })
    );
  }

  @Action(GarageActions.SendGroupEmail)
  sendGroupEmail(
    context: StateContext<GarageStateModel>,
    action: GarageActions.SendGroupEmail
  ) {
    const errorMessage = "Błąd wysyłania wiadomości e-mail.";

    this.garageService.sendEmail(action.GroupEmail).subscribe(
      (ret) => {
        this.bannerService.success("Wiadmość email została wysłana.");
      },
      (error) => {
        this.helperService.SaveException("GarageActions.SendGroupEmail", error);

        this.bannerService.error(errorMessage);
      }
    );
  }

  @Action(GarageActions.SendGroupMessage)
  sendGroupMessage(
    context: StateContext<GarageStateModel>,
    action: GarageActions.SendGroupMessage
  ) {
    const errorMessage = "Błąd wysyłania wiadomości grupowej.";

    this.garageService.sendMessage(action.GroupMessage).subscribe(
      (ret) => {
        this.bannerService.success(
          `Wiadmość grupowa została wysłana do ${ret} odbiorców.`
        );
        context.dispatch(new GarageActions.GetLastGroupMessage());
      },
      (error) => {
        this.helperService.SaveException(
          "GarageActions.SendGroupMessage",
          error
        );

        this.bannerService.error(errorMessage);
      }
    );
  }

  @Action(GarageActions.GetGroupMessages)
  getGroupMessages(
    context: StateContext<GarageStateModel>,
    action: GarageActions.GetGroupMessages
  ) {
    const errorMessage = "Błąd pobierania wiadomości grupowych.";

    this.garageService.getGroupMessages().subscribe(
      (ret) => {
        if (ret.Success) {
          ret.Items.forEach((item) => {
            this.bannerService.instantMessage(`${item.Message}`);
          });
        }
      },
      (error) => {
        this.helperService.SaveException(
          "GarageActions.getGroupMessages",
          error
        );

        this.bannerService.error(errorMessage);
      }
    );
  }

  @Action(GarageActions.GetLastGroupMessage)
  getLastGroupMessage(
    context: StateContext<GarageStateModel>,
    action: GarageActions.GetLastGroupMessage
  ) {
    context.setState(
      patch({
        LastGroupMesage: null,
      })
    );
    const errorMessage =
      "Błąd pobierania informacji o ostatniej wiadomości grupowej.";

    this.garageService.getLastGroupMessage().subscribe(
      (ret) => {
        if (ret.Success) {
          context.setState(
            patch({
              LastGroupMesage: ret.Item,
            })
          );
        }
      },
      (error) => {
        this.helperService.SaveException(
          "GarageActions.GetLastGroupMessage",
          error
        );

        this.bannerService.error(errorMessage);
      }
    );
  }

  @Action(GarageActions.GetGarageReportFiltered)
  getReportFiltered(
    context: StateContext<GarageStateModel>,
    action: GarageActions.GetGarageReportFiltered
  ) {

    const fileName = "Serwisy-Wyfiltrowane";

    this.bannerService.info(
      `Rozpoczęto generowanie pliku raportu ${fileName}, proszę czekać ...`,
      "Export danych"
    );

    this.PatchReportContext(action.ReportName, true, context);

    this.garageService.getReport(action.Search).subscribe(
      (res) => {
        const file = new File(
          [res],
          `${fileName}-${this.helperService.TimeStamp()}.xlsx`,
          {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          }
        );
        saveAs(file);

        this.PatchReportContext(action.ReportName, false, context);
      },
      (res) => {

        this.PatchReportContext(action.ReportName, false, context);

        this.bannerService.error(`Błąd pobierania raportu: ${fileName}`);
      },
      () => {

        this.PatchReportContext(action.ReportName, false, context);

        this.helperService.consoleLog(
          "@Action(GarageActions.GetGarageReportFiltered)"
        );
      }
    );
  }

  @Action(GarageActions.GetGarageReportFilteredWithDeposites)
  getReportFilteredWithDeposites(
    context: StateContext<GarageStateModel>,
    action: GarageActions.GetGarageReportFilteredWithDeposites
  ) {

    this.PatchReportContext(action.ReportName, true, context);

    const fileName = "Serwisy-Wyfiltrowane-Depozyty";
    this.bannerService.info(
      `Rozpoczęto generowanie pliku raportu ${fileName}, proszę czekać ...`,
      "Export danych"
    );

    this.garageService.getReportWithDeposites(action.Search).subscribe(
      (res) => {

        const file = new File(
          [res],
          `${fileName}-${this.helperService.TimeStamp()}.xlsx`,
          {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          }
        );
        saveAs(file);

        this.PatchReportContext(action.ReportName, false, context);
      },
      (res) => {
        this.PatchReportContext(action.ReportName, false, context);

        this.bannerService.error(`Błąd pobierania raportu: ${fileName}`);
      },
      () => {
        this.PatchReportContext(action.ReportName, false, context);

        this.helperService.consoleLog(
          "@Action(GarageActions.GetGarageReportFiltered)"
        );
      }
    );
  }

  @Action(GarageActions.GetGarageLocation)
  GetGarageLocation(
    context: StateContext<GarageStateModel>,
    action: GarageActions.GetGarageLocation
  ) {
    function patchContext(list: GarageModels.GarageLocationListModel) {
      context.setState(
        patch({
          GarageLocations: list,
        })
      );
    }
    const emptyResponse = new GarageModels.GarageLocationListModel();

    patchContext(null);
    this.garageService.getLocations(action.Search).subscribe(
      (data) => {
        if (data.Success) {
          patchContext(data);
        } else {
          patchContext(emptyResponse);
        }
      },
      (error) => {
        patchContext(emptyResponse);
        this.bannerService.error("Błąd pobierania lokalizacji serwisów.");
        this.helperService.SaveException(
          "GarageActions.GetGarageLocation",
          error
        );
      }
    );
  }

  @Action(GarageActions.GetGarageReportFilteredForCustomer)
  getGarageReportFilteredForCustomer(
    context: StateContext<GarageStateModel>,
    action: GarageActions.GetGarageReportFiltered
  ) {

    this.PatchReportContext(action.ReportName, true, context);

    const fileName = "Serwisy-Wyfiltrowane-Klient";

    this.bannerService.info(
      `Rozpoczęto generowanie pliku raportu ${fileName}, proszę czekać ...`,
      "Export danych"
    );

    this.garageService.getCustomerReport(action.Search).subscribe(
      (res) => {
        const file = new File(
          [res],
          `${fileName}-${this.helperService.TimeStamp()}.xlsx`,
          {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          }
        );
        saveAs(file);

        this.PatchReportContext(action.ReportName, false, context);
      },
      (res) => {
        this.PatchReportContext(action.ReportName, false, context);

        this.bannerService.error(`Błąd pobierania raportu: ${fileName}`);
      },
      () => {
        this.PatchReportContext(action.ReportName, false, context);

        this.helperService.consoleLog(
          "@Action(GarageActions.GetGarageReportFilteredForCustomer)"
        );
      }
    );
  }

  @Action(GarageActions.DisposeSearch)
  disposeSearch(context: StateContext<GarageStateModel>) {
    context.setState(
      patch({
        GarageSearch: null,
      })
    );
  }

  @Action(GarageActions.SetGarageDiscount)
  setGarageDiscount(
    context: StateContext<GarageStateModel>,
    action: GarageActions.SetGarageDiscount
  ) {

    context.setState(
      patch({
        GarageDiscountTemplate: null,
        GarageDiscount: null
      })
    );

    this.garageService.setGarageDiscount(action.Garage).subscribe(
      (data) => {
        if (data.Success == true) {

          context.setState(
            patch({
              GarageDiscountTemplate: data,
              GarageDiscount: data
            })
          );
        }

      },
      (error) => {

        context.setState(
          patch({
            GarageDiscountTemplate: null,
            GarageDiscount: null,
          })
        );

        this.bannerService.error("Błąd zapisu listy rabatów.");
        this.helperService.SaveException("GarageActions.SetGarageDiscount", error);
      }
    );
  }

  @Action(GarageActions.GetGarageDiscount)
  getGarageDiscount(
    context: StateContext<GarageStateModel>,
    action: GarageActions.GetGarageDiscount
  ) {

    context.setState(
      patch({
        GarageDiscount: null,
      })
    );

    this.garageService.getGarageDiscount(action.Garage).subscribe(
      (data) => {
        if (data.Success == true) {

          context.setState(
            patch({
              GarageDiscount: data,
            })
          );
        }

      },
      (error) => {

        context.setState(
          patch({
            GarageDiscount: null,
          })
        );

        this.bannerService.error("Błąd pobierania listy rabatów.");
        this.helperService.SaveException("GarageActions.GetGarageDiscount", error);
      }
    );
  }

  @Action(GarageActions.GetGarageDiscountTemplate)
  getGarageDiscountTemplate(
    context: StateContext<GarageStateModel>,
    action: GarageActions.GetGarageDiscount
  ) {

    context.setState(
      patch({
        GarageDiscountTemplate: null,
      })
    );

    this.garageService.getGarageDiscountTemplate(action.Garage).subscribe(
      (data) => {
        if (data.Success == true) {

          context.setState(
            patch({
              GarageDiscountTemplate: data,
            })
          );
        }

      },
      (error) => {

        context.setState(
          patch({
            GarageDiscountTemplate: null,
          })
        );

        this.bannerService.error("Błąd pobierania listy rabatów.");
        this.helperService.SaveException("GarageActions.GetGarageDiscountTemplate", error);
      }
    );
  }

  @Action(GarageActions.GetGarageDiscountExcelReport)
  getGarageServicePriceReport(
    context: StateContext<GarageStateModel>,
    action: GarageActions.GetGarageDiscountExcelReport
  ) {

    this.PatchReportContext(action.ReportName, true, context);

    const fileName = "Rabaty Serwisu";
    this.bannerService.info(
      `Rozpoczęto generowanie pliku raportu ${fileName}, proszę czekać ...`,
      "Export danych"
    );

    this.garageService.getGarageDiscountExcelReport(action.Search).subscribe(
      (res) => {
        const file = new File(
          [res],
          `${fileName}-${this.helperService.TimeStamp()}.xlsx`,
          {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          }
        );
        saveAs(file);

        this.PatchReportContext(action.ReportName, true, context);
      },
      (res) => {
        this.PatchReportContext(action.ReportName, true, context);

        this.bannerService.error(`Błąd pobierania raportu: ${fileName}`);
      },
      () => {
        this.PatchReportContext(action.ReportName, true, context);

        this.helperService.consoleLog(
          "@Action(GarageActions.GetGarageDiscountExcelReport)"
        );
      }
    );
  }

  @Action(GarageActions.SetImportGarageDiscountStatus)
  SetImportStatus(
    context: StateContext<GarageStateModel>,
    action: GarageActions.SetImportGarageDiscountStatus
  ) {
    context.setState(
      patch({
        ImportGarageDiscountStatus: action.Status
      })
    );
  }

  @Action(GarageActions.ImportGarageDiscountList)
  Import(
    context: StateContext<GarageStateModel>,
    action: GarageActions.ImportGarageDiscountList
  ) {

    this.bannerService.quickInfo('Rozpoczęto import Rabatów, proszę czekać.');

    this.garageService.importGarageDiscount(action.Data).subscribe(ret => {

      this.helperService.consoleLog(ret.headers);

      const processed = ret.headers.get('x-import-processed');
      const error = ret.headers.get('x-import-error');
      const result = ret.headers.get('x-import-result');
      const message = ret.headers.get('x-import-message');
      const imported = Number(ret.headers.get('x-import-imported'));

      if (result === 'OK') {

        context.dispatch(new GarageActions.SetImportGarageDiscountStatus(true));

        const file = new File([ret.body], `Wynik-Importu-${this.helperService.TimeStamp()}-${action.FileName}`, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        if (imported > 0) {
          this.bannerService.instantSuccess(`Zakończono import pliku <b>${action.FileName}</b><br/><b>Zaimportowano ${imported}</b> pozycji.<br/>Przetworzono <b>${processed}</b> wierszy.<br/>Znaleziono <b>${error}</b> wierszy z błędami.`);
        }
        else {
          this.bannerService.instantMessage(`Zakończono import pliku <b>${action.FileName}</b><br/><b>Nie zaimporotwano żadnych pozycji</b>.<br/>Przetworzono <b>${processed}</b> wierszy.<br/>Znaleziono <b>${error}</b> wierszy z błędami.`);
        }

        saveAs(file);
      } else {

        if (message === 'IMPORT_EXCEPTION_EMPTY_FILE') {
          this.bannerService.instantError(`Zakończono import pliku <b>${action.FileName}</b><br/>Plik przeznaczony do importu jest pusty.`);
        } else if (message === 'IMPORT_EXCEPTION_INVALID_FILE_EXTENSION') {
          this.bannerService.instantError(`Zakończono import pliku <b>${action.FileName}</b><br/>Plik przeznaczony do importu ma niewłaściwe rozszerzenie.`);
        } else if (message === 'IMPORT_EXCEPTION_INVALID_HEDER') {
          this.bannerService.instantError(`Zakończono import pliku <b>${action.FileName}</b><br/>Plik przeznaczony do importu ma niewłaściwy nagłówek.`);
        } else {
          this.bannerService.instantError(`Zakończono import pliku <b>${action.FileName}</b><br/>Wystąpił nieznany błąd podczas przetwarzania pliku.`);
        }
      }
    },
      (error) => {

        this.helperService.SaveException('GarageActions.ImportGarageDiscountList', error);

        this.bannerService.error('Błąd importu cennika.');

        context.dispatch(new GarageActions.SetImportGarageDiscountStatus(false));
      },
      () => {
        context.dispatch(new GarageActions.SetImportGarageDiscountStatus(false));
      }
    );
  }

  @Action(GarageActions.SetCommission)
  setCommission(
    context: StateContext<GarageStateModel>,
    action: GarageActions.SetCommission
  ) {
    const errorMessage = "Błąd ustawiania prowizji.";

    this.garageService.setCommission(action.Commission).subscribe(
      (ret) => {
        this.bannerService.success(
          `Prowizja została ustawiona dla ${ret} serwisów.`
        );
        context.dispatch(new GarageActions.GetLastGroupMessage());
      },
      (error) => {
        this.helperService.SaveException(
          "GarageActions.SetCommission",
          error
        );

        this.bannerService.error(errorMessage);
      }
    );
  }
}
